export enum OpiTriggerTypeEnum {
  PREAUTH = 'preauth',
  CONFIRMPREAUTH = 'confirmpreauth',
  TOPUP = 'topup',
  RELEASE = 'release',
  CHECKOUT = 'checkout'
}
